import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    defaultMessage: "Rules",
    id: "kAAlGL",
  },
  addRule: {
    defaultMessage: "Add rule",
    id: "gzM1em",
  },
  catalog: {
    defaultMessage: "Catalog",
    id: "GOdq5V",
  },
  catalogDescription: {
    defaultMessage: "Discount rules for products, collections or categories.",
    id: "ucLtY8",
  },
  placeholder: {
    defaultMessage: "Add your first rule to set up a promotion",
    id: "XtlUj6",
  },
  conditions: {
    defaultMessage: "Conditions",
    id: "S8kqP9",
  },
  discountValue: {
    defaultMessage: "Discount value",
    id: "kNK4es",
  },
  reward: {
    defaultMessage: "Reward",
    id: "PuQb0P",
  },
  catalogRule: {
    id: "A7W4KO",
    defaultMessage: "Catalog rule",
  },
  ruleSummary: {
    id: "NgRa6m",
    defaultMessage:
      "Discount of {value} on the purchase of {items} through the {channel}",
  },
  ruleSummaryWithoutConditions: {
    id: "7MUx0T",
    defaultMessage: "Discount of {value} through the {channel}",
  },
  ruleSummaryMoreItems: {
    id: "B0fwAj",
    defaultMessage: "and {itemsLength} more",
  },
  createRule: {
    id: "9d24PR",
    defaultMessage: "Create rule",
  },
  editRule: {
    id: "v1vJ77",
    defaultMessage: "Edit rule",
  },
  ruleError: {
    id: "zehNKT",
    defaultMessage: "Rule has error, open rule to see details",
  },
  deleteRule: {
    id: "MdFdbd",
    defaultMessage: "Delete rule",
  },
  deleteRuleDescription: {
    id: "XVuPMw",
    defaultMessage: "Are you sure you want to delete this rule?",
  },
  noChannelsSelected: {
    id: "w7jT4W",
    defaultMessage: "No channels selected",
  },
  noConditonsCreate: {
    id: "Xu4ST7",
    defaultMessage: "No conditions added, click button bellow to create one",
  },
});
